/**
 * Strategy Constants
 *
 * Shared constants for parlay strategy configuration and user history settings.
 * Used by both frontend (config panel) and backend (AI pick generation).
 */

// =============================================================================
// Parlay Strategy Defaults
// =============================================================================

/** Default minimum legs per parlay (1 = straight bets allowed) */
export const DEFAULT_MIN_LEG_COUNT = 1;

/** Default maximum legs per parlay */
export const DEFAULT_MAX_LEG_COUNT = 5;

/** Default minimum target odds (American format, e.g., +150) */
export const DEFAULT_TARGET_ODDS_MIN = 150;

/** Default maximum target odds (American format, e.g., +350) */
export const DEFAULT_TARGET_ODDS_MAX = 350;

// =============================================================================
// User History Settings
// =============================================================================

/** Default number of recent legs to include in user profile for AI context */
export const DEFAULT_HISTORY_LIMIT = 50;

/** Maximum history limit (used when user selects "unlimited") */
export const MAX_HISTORY_LIMIT = 500;

/** Minimum settled legs required for user history to be meaningful */
export const MIN_HISTORY_THRESHOLD = 10;

// =============================================================================
// User Profile Output Caps (prevents prompt bloat)
// =============================================================================

/** Maximum "strong prefer" players to include in AI prompt */
export const MAX_STRONG_PLAYERS = 5;

/** Maximum "good" players to include in AI prompt */
export const MAX_GOOD_PLAYERS = 8;

/** Maximum "avoid" players to include in AI prompt */
export const MAX_AVOID_PLAYERS = 5;

/** Maximum best prop types to include in AI prompt */
export const MAX_BEST_PROPS = 5;
